import { useGetDriveFiles } from "hooks/useGetDriveFiles";
import { Button, CircularProgress } from "@mui/material";

interface DriveFilesProps {
  onSelectFile: (file: any) => void;
}

export const DriveFiles = ({ onSelectFile }: DriveFilesProps) => {
  const { data, isLoading } = useGetDriveFiles();
  return (
    <div>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <div>
          {data?.files?.map((file: any) => (
            <div key={file.id}>
              <div>{file.name}</div>
              <div>{file.mimeType}</div>
              <div>
                <Button variant="contained" onClick={() => onSelectFile(file.id)}>
                  Выбрать
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
